// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toast Styles */
.toast-container {
    position: fixed;
    top: 1rem;
    right: 1rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    z-index: 9999;
}

.toast {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 200px;
    padding: 10px 16px;
    border-radius: 8px;
    color: white;
    animation: fadeIn 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.toast.info {
    background-color: #3498db;
}

.toast.success {
    background-color: #2ecc71;
}

.toast.error {
    background-color: #e74c3c;
}

.toast button {
    background: none;
    border: none;
    color: white;
    font-weight: bold;
    cursor: pointer;
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}`, "",{"version":3,"sources":["webpack://./src/ToastNotifications/styles.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ","sourcesContent":["/* Toast Styles */\n.toast-container {\n    position: fixed;\n    top: 1rem;\n    right: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    z-index: 9999;\n}\n\n.toast {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    min-width: 200px;\n    padding: 10px 16px;\n    border-radius: 8px;\n    color: white;\n    animation: fadeIn 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.toast.info {\n    background-color: #3498db;\n}\n\n.toast.success {\n    background-color: #2ecc71;\n}\n\n.toast.error {\n    background-color: #e74c3c;\n}\n\n.toast button {\n    background: none;\n    border: none;\n    color: white;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(-10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
